import ReactLoadingSkeleton from 'react-loading-skeleton';

import type { SkeletonProps } from '../Skeleton.types';

export const FiltersBarSkeleton = ({ count = 3, ...props }: SkeletonProps) => {
  const items = Array.from({ length: count }, (_, i) => i);
  return (
    <div className="flex w-full flex-row items-center font-normal" data-testid="skeleton-filters-bar" {...props}>
      {items.map((i) => (
        <div className="mr-2 flex h-7 gap-2 rounded-sm border border-neutral-300 bg-white p-1.5 leading-[14px]" key={i}>
          <ReactLoadingSkeleton height={14} width={16} />
          <ReactLoadingSkeleton height={14} width={172} />
        </div>
      ))}
    </div>
  );
};
